<template>
  <div class="columns">
    <div class="column">
      <MglMap
        class="home-map"
        :accessToken="accessToken"
        :mapStyle="mapStyle"
        :zoom="15"
        :center="center"
        @drag="onMapDrag"
        @load="setCenter"
        @mousedown="onMapClick"
      >
        <MglMarker
          v-for="group in mapGroups"
          :key="group.id"
          :coordinates="group.address_geo"
        >
          <div slot="marker">
            <div @click="showGroup(group)" class="map-marker">
              <figure class="image is-24x24">
                <img
                  v-if="group.cover"
                  class="is-rounded"
                  :src="group.cover.thumb_url"
                />
              </figure>
            </div>
          </div>
        </MglMarker>
      </MglMap>
      <div class="home-gradient"></div>
      <section class="home container">
        <div
          class="columns is-mobile is-tablet is-desktop tw-h-screen tw-items-center"
        >
          <div class="column is-narrow">
            <div class="home-stat tw-py-5">
              <p class="stat-count">{{ stats.active_ltgs }}</p>
              <p class="stat-title">Active Groups</p>
            </div>

            <div class="home-stat tw-py-5">
              <p class="stat-count">{{ stats.students }}</p>
              <p class="stat-title">AMAZING students</p>
            </div>

            <!-- <div class="home-stat">
              <p class="stat-count">{{ stats.projects }}</p>
              <p class="stat-title">LIVE.LOUD projects</p>
            </div> -->

            <div class="home-stat tw-py-5">
              <p class="stat-count">{{ stats.stories }}</p>
              <p class="stat-title">Stories of empowerment</p>
            </div>
          </div>
          <div class="column is-full-mobile"></div>
          <div class="column column-feature is-one-quarter-desktop">
            <feature-box :group="selectedGroup" />
          </div>
        </div>
        <div class="columns is-hidden-desktop is-hidden-tablet tw-mt-5">
          <div id="featurebox" class="column is-one-quarter-desktop">
            <feature-box :group="selectedGroup" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { MglMap, MglMarker } from 'vue-mapbox'
import { first, debounce } from 'lodash'
import { defaultMapboxCenter } from '@/services/const'
import Mapbox from 'mapbox-gl'
import env from '@/services/env'
import FeatureBox from './components/FeatureBox'

export default {
  components: {
    MglMap,
    MglMarker,
    FeatureBox
  },
  data() {
    return {
      center: defaultMapboxCenter,
      accessToken: env.mapBoxToken,
      mapStyle: 'mapbox://styles/mapbox/outdoors-v11',
      selectedGroup: null
    }
  },
  async created() {
    this.mapbox = Mapbox
    this.getHomeStats()
    await this.getMapGroups()
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      stats: state => state.homeStats,
      mapGroups: state => state.mapGroups
    })
  },
  methods: {
    ...mapActions({
      getHomeStats: 'getHomeStats',
      getMapGroups: 'getMapGroups'
    }),
    ...mapMutations({
      setMapGroups: 'setMapGroups'
    }),
    setCenter() {
      const center = first(this.mapGroups)
      this.center = center ? center.address_geo : defaultMapboxCenter
    },
    onMapDrag: debounce(function() {}, 1000),
    onMapClick() {
      this.selectedGroup = null
    },
    showGroup(group) {
      this.selectedGroup = group
      this.$nextTick(() => {
        document.getElementById('featurebox').scrollIntoView()
      })
    }
  },
  watch: {
    async 'auth.isAuthenticated'(isAuthenticated) {
      if (isAuthenticated) {
        await this.getMapGroups()
        this.setCenter()
      }
    }
  }
}
</script>
